const BLOG = 'blog';
const SUCCESS_STORY = 'caso';

module.exports = {
  BLOG,
  SUCCESS_STORY,
};
